<template>
  <div id="booking" class="longInfo">

    <div class="greenSpinner" v-show="pageLoading">
      <md-spinner md-indeterminate :md-size="90" :md-stroke="1.8" class="md-primary" md-theme="teal"></md-spinner>
      <p class="md-subheading" style="top:45vh; position: relative; display:block; z-index: 120; text-align:center; color:#ffffff;">Daten werden geladen</p>
    </div>

    <md-toolbar class="listBar">
      <md-button class="md-icon-button" @click="goBack()">
        <md-icon>close</md-icon>
      </md-button>

      <h2 class="md-title">{{ pageTitle }}</h2>

      <md-button @click="goScan()" class="md-icon-button">
        <md-icon>qr_code</md-icon>
      </md-button>

    </md-toolbar>
    <md-list style="top:84px; height:100vh !important;">
      <div id="drp-booking" data-booking-platform="TENDU"></div>
    </md-list>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'

export default {
  name: 'booking',
  data: () => ({
    pageTitle: 'Kurse buchen',
  }),

  computed: {
    ...mapState([
      'isNavigate',
      'isBack',
      'pageLoading'
    ]),
  },

  beforeMount() {
    this.changePageLoading(true)
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.dr-plano.com/de/static/booking-plugin/code.js')
    recaptchaScript.setAttribute('id', 'drp-script')
    recaptchaScript.setAttribute('data-backend-url', 'https://backend.dr-plano.com')
    recaptchaScript.setAttribute('data-id', '28872672')
    recaptchaScript.setAttribute('data-frontend-url', 'https://www.dr-plano.com/de')
    document.head.appendChild(recaptchaScript)
  },

  mounted() {
    setTimeout(() => {
      this.changePageLoading(false)
    }, 2500)

  },

  methods: {
    ...mapMutations([
      'changeNavigate',
      'UPDATE_NUMBER',
      'changeBack',
      'changePageLoading'
    ]),

    goScan () {
      this.$router.push('/Scan')
    },

    goBack () {
      this.$router.go(-1)
    },
  }
}

</script>

<style>

  #iconInfo .material-icons {
    font-size:17px !important;
    vertical-align: sub !important;
    color: #00838f;
    }

  #info b {
    color: #00838f;
  }

  .fa-qrcode:before {
    font-size: 20px !important;
    vertical-align: sub;
    color: #00838f;
  }

  .qricon {
    width:20px;
    height:20px;
  }

</style>
